import { stopEvent } from '../../utils/event-utils';
import { uiRouterStateModule } from '../../vendor/ui-router-module';

export const uiSrefNoLinkDirectiveModule = angular
  .module('Q.components.ui-sref-no-link', [uiRouterStateModule])

  /**
   * @ngdoc directive
   * @name uiSrefNoLink
   * @description
   * Directive that replicates ui-sref without setting the href property on a link.
   * This is used in the Assess app to prevent opening challenges in a new window.
   *
   * @element ANY
   * @param {template} uiSrefNoLink sref
   * @param {template} uiSrefDisableOnTransition Disable while in a transition
   * @param {expression=} uiSrefOpts Options to pass to the state
   */
  .directive('uiSrefNoLink', function ($state) {
    function parseStateRef(ref, current) {
      const preparsed = ref.match(/^\s*({[^}]*})\s*$/);
      let parsed;
      if (preparsed) ref = `${current}(${preparsed[1]})`;
      parsed = ref.replace(/\n/g, ' ').match(/^([^(]+?)\s*(\((.*)\))?$/);
      if (!parsed || parsed.length !== 4)
        throw new Error(`Invalid state ref '${ref}'`);
      return { state: parsed[1], paramExpr: parsed[3] || null };
    }

    return {
      restrict: 'A',
      require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
      link: function (scope, element, attrs, uiSrefActive) {
        const ref = parseStateRef(attrs.uiSrefNoLink, $state.current.name);
        const def = { state: ref.state, params: null };
        const active = uiSrefActive[1] || uiSrefActive[0];

        def.options = angular.extend(
          {
            relative: $state.$current,
            inherit: true,
          },
          attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {},
        );

        const update = function (val) {
          if (val) def.params = angular.copy(val);
          // eslint-disable-next-line angular/no-private-call
          if (active) active.$$addStateInfo(ref.state, def.params);
        };

        if (ref.paramExpr) {
          scope.$watch(
            ref.paramExpr,
            function (val) {
              if (val !== def.params) update(val);
            },
            true,
          );
          def.params = angular.copy(scope.$eval(ref.paramExpr));
        }
        update();

        element.bind('click', (event) => {
          stopEvent(event);
          const disabled =
            element.attr('disabled') ||
            (attrs.uiSrefDisableOnTransition && $state.transition);
          if (
            !disabled &&
            (def.options.reload || !$state.is(def.state, def.params))
          ) {
            // don't redirect if nothing has changed
            $state.go(def.state, def.params, def.options);
          }
        });
      },
    };
  });
